import React from 'react';
import { SlideFrame } from './SlideFrame';
const acts = [{
  act: 'Act I',
  phase: 'Before',
  title: 'Set the scene',
  scope: ['1 × Pre-ECCO teaser / poll'],
  purpose: 'Start the discourse, introduce the clinical tension and collect the first audience signals.'
}, {
  act: 'Act II',
  phase: 'During',
  title: 'Create the conversation',
  scope: ['1 × Aisle-breaker experience', '1 × Rep-guided adaptive Trailer', '1 × Self-guided congress version', '1 × Peer-poll layer'],
  purpose: 'Move HCPs from curiosity into dialogue and let their interests shape the conversation.'
}, {
  act: 'Act III',
  phase: 'After',
  title: 'Turn ideas into action',
  scope: ['1 × Post-ECCO insight / follow-up Snak'],
  purpose: 'Give the knowledge back, create relevant follow-up and turn congress engagement into the next action.'
}];
const throughline = ['Analytics', 'Insights', 'Recommendations', 'Optimization where relevant'];
export function FirstProductionSlide() {
  return <SlideFrame topBand eyebrow="The first production" data-id="element-155" data-mp="3eu29sh90mi0o">
      <header className="grid grid-cols-[1.15fr_0.85fr] items-end gap-[5vw]" data-id="element-156" data-mp="39y3jup81gry5">
        <h1 className="max-w-[14ch] font-display text-[clamp(43px,5.7vw,94px)] font-bold leading-[0.96] tracking-[-0.03em]" data-id="element-157" data-mp="34xfqvy09211a">
          Start small. Connect the three acts.
        </h1>
        <p className="mb-[0.5vh] max-w-[38ch] font-sans text-[clamp(13px,1.05vw,19px)] leading-snug text-black/55" data-id="element-158" data-mp="2vx0ti0a0gvhf">
          We don’t need to redesign the entire ECCO campaign to create value.
        </p>
      </header>

      <div className="relative mt-[2.5vh] grid min-h-0 flex-1 grid-cols-3 gap-[2vw] border-y border-black/20 py-[1.7vh]" data-id="element-159" data-mp="2m6pqcfy5iqbl">
        <div className="pointer-events-none absolute left-[4%] right-[4%] top-[2.6vh] h-px bg-[#D62B22]" aria-hidden="true" data-id="element-160" data-mp="2h9pfzsu9r1eo" />
        {acts.map((act, index) => <section key={act.act} className={`relative z-10 flex min-h-0 flex-col bg-[#F4F1E8] ${index > 0 ? 'border-l border-black/15 pl-[2vw]' : ''}`} data-id="element-161" data-mp="2876i7n5cbeza" data-mpi={index}>
            <div className="flex items-center gap-[0.8vw]" data-id="element-162" data-mp="1yisu40h17kd8">
              <span className={`flex size-[clamp(28px,2.7vw,48px)] items-center justify-center rounded-full border-[clamp(2px,0.22vw,4px)] border-[#D62B22] bg-[#F4F1E8] font-sans text-[clamp(9px,0.7vw,13px)] font-bold ${index === 1 ? 'bg-[#D62B22] text-white' : 'text-[#D62B22]'}`} data-id="element-163" data-mp="22lxsprxzr1wl">
                0{index + 1}
              </span>
              <div data-id="element-164" data-mp="2hbdip5pp73b8">
                <p className="font-sans text-[clamp(9px,0.72vw,13px)] font-semibold tracking-[0.1em] text-black/35" data-id="element-165" data-mp="2hcy3i3m7n7vw">{act.act}</p>
                <p className="font-sans text-[clamp(10px,0.82vw,15px)] font-semibold text-[#D62B22]" data-id="element-166" data-mp="27laj2mo2mr3x">{act.phase}</p>
              </div>
            </div>

            <h2 className="mt-[1vh] max-w-[13ch] font-display text-[clamp(20px,1.9vw,34px)] font-semibold leading-[1.02]" data-id="element-167" data-mp="2ci0tatd72shf">{act.title}</h2>

            <div className="mt-[1.1vh] divide-y divide-black/15 border-y border-black/15" data-id="element-168" data-mp="34zwj6z2iabsr">
              {act.scope.map(item => <p key={item} className="py-[0.48vh] font-sans text-[clamp(10px,0.82vw,15px)] font-medium leading-tight text-black/65" data-id="element-169" data-mp="tjw8dn1c98g1">{item}</p>)}
            </div>

            <p className="mt-auto pt-[1vh] font-sans text-[clamp(10px,0.78vw,14px)] leading-snug text-black/45" data-id="element-170" data-mp="12dr5c7sb3skl">
              <span className="font-semibold text-black/60" data-id="element-171" data-mp="yd7710vzyiwv">Purpose: </span>{act.purpose}
            </p>
          </section>)}
      </div>

      <div className="mt-[1.3vh] flex items-center gap-[1.3vw] border-b border-black/20 pb-[1.1vh]" data-id="element-172" data-mp="ao63ns20txyg">
        <span className="font-sans text-[clamp(9px,0.72vw,13px)] font-semibold tracking-[0.1em] text-[#D62B22]" data-id="element-173" data-mp="5pl13lzar26u">Throughout</span>
        {throughline.map((item, index) => <React.Fragment key={item} data-id="element-174" data-mp="emlphsmd90aa" data-mpi={index}>
            <span className="font-sans text-[clamp(10px,0.82vw,15px)] font-medium text-black/55" data-id="element-175" data-mp="1v1wquwr6pllh">{item}</span>
            {index < throughline.length - 1 ? <span className="h-px flex-1 bg-black/15" data-id="element-176" data-mp="1q2k389shoahu" /> : null}
          </React.Fragment>)}
      </div>

      <footer className="mt-[1.4vh] grid grid-cols-[1.1fr_0.9fr] items-end gap-[4vw]" data-id="element-177" data-mp="2lf33ot3voixu">
        <p className="font-display text-[clamp(22px,2.45vw,42px)] font-semibold leading-[1.02]" data-id="element-178" data-mp="2qcv5qfy8llfr">
          One strategic question. One narrative. <span className="text-[#D62B22]" data-id="element-179" data-mp="30aj21abhr101">Three connected acts.</span>
        </p>
        <div className="text-right" data-id="element-180" data-mp="308g0pu4w1lg0">
          <p className="font-sans text-[clamp(10px,0.86vw,16px)] leading-snug text-black/55" data-id="element-181" data-mp="34cnsk06n7hig">All built from Takeda’s existing strategy, approved content and congress assets.</p>
          <p className="mt-[0.45vh] font-sans text-[clamp(9px,0.74vw,14px)] leading-snug text-black/35" data-id="element-182" data-mp="3e1xlfi9b947m">Snakker complements the lead ECCO agency by creating the interactive engagement layer.</p>
        </div>
      </footer>
    </SlideFrame>;
}